export enum WebConfigEn {
  theme = 'theme',
  language = 'lang',
  english = 'en',
  vietnamese = 'vi',
  light = 'light',
  dark = 'dark'
}
